export default __webpack_public_path__ + "985fc269568474f63488b1eb15e207bb.png";